<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('btnFinishAvailable', $event)" />

    <v-row class="mx-auto">
      <v-col id="saneamento-voc-calculo-racionalizacao-com" cols="12" class="pl-2 pt-0">
        <v-checkbox v-model="_campos.calculoRacionalizacaoDoCom" label="Executar calculo de Racionalização do COM?" />
      </v-col>
    </v-row>

    <template v-if="_campos.calculoRacionalizacaoDoCom == true">
      <saneamento-voc-choose-paramentros-com-ca
        divId="saneamento-voc-cmu"
        titulo="CMU - Custo Médio Unitário"
        nomeParametro="CMU"
        :items="cmuExistentes"
        :campos.sync="_campos"
        linkCadastros="/parametros-com-ca/cmu"
        parametro="cmu"
      />

      <saneamento-voc-choose-paramentros-com-ca
        divId="saneamento-voc-normas-tecnicas"
        titulo="Normas Técnicas"
        nomeParametro="Normas Técnicas"
        :items="normasTecnicasExistentes"
        :campos.sync="_campos"
        linkCadastros="/parametros-com-ca/normas-tecnicas"
        parametro="normasTecnicas"
      />

      <v-row v-if="isLight" class="mx-auto">
        <v-col cols="12">
          <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">Tipo de Cálculo</span>
          <span></span>
        </v-col>

        <v-col id="saneamento-voc-tipo-calculo" cols="12">
          <v-select
            v-model="_campos.tipoCalculo"
            :items="_campos.tipoCalculoList"
            label="Tipo de Cálculo"
            :placeholder="`Selecione o tipo de cálculo`"
            outlined
          />
        </v-col>
      </v-row>
    </template>
  </validation-observer>
</template>

<script>
  export default {
    name: 'SaneamentoVocFourthWizardTab',

    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      SaneamentoVocChooseParamentrosComCa: () => import('@/components/saneamentoVoc/SaneamentoVocChooseParamentrosComCa.vue')
    },

    props: {
      campos: {
        type: Object,
        required: true
      },
      cmuExistentes: {
        type: Array,
        required: true
      },
      normasTecnicasExistentes: {
        type: Array,
        required: true
      }
    },

    emits: ['btnFinishAvailable', 'update:campos'],

    data: () => ({
      parametros: [],
      tipoCalculoList: ['ANEEL', 'DISTRIBUIDORA']
    }),

    computed: {
      _campos: {
        get() {
          return this.campos;
        },
        set(newValues) {
          this.$emit('update:campos', newValues);
        }
      },
      isLight() {
        const sigla = this.$store.getters.getSiglaEmpresa.toUpperCase();
        return ['LIGHT', 'LIGHT-E'].includes(sigla);
      }
    }
  };
</script>

<style></style>
